import React from 'react';

const ModalTabs = ({ tabs, activeTab, onTabChange }) => (
  <div className="modal-tabs">
    {tabs.map(({ id, icon: Icon, label }) => (
      <button
        key={id}
        type="button"
        className={`modal-tab-btn${activeTab === id ? ' modal-tab-btn--active' : ''}`}
        onClick={() => onTabChange(id)}
      >
        {Icon && <Icon size={14} />}
        {label}
      </button>
    ))}
  </div>
);

export default ModalTabs;
